import { ModalContent } from "../store/enums/ModalContent";
import { useAppStore } from "./useAppStore";

export const useModalContent = () => {
  const {appStore: { modalContent }, appStoreDispatch} = useAppStore();

  const updateModalContent = (content: ModalContent) => {
    appStoreDispatch('setModalContent', content);
  }

  return {modalContent, updateModalContent};
}